import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC, useEffect } from 'react';

import { useCallContext } from '@gem/call/CallView/CallView.context';

import { AnimatedBackgroundPanel } from '../Shared/AnimatedBackgroundPanel/AnimatedBackgroundPanel';
import { EventsBar } from '../Shared/EventsBar/EventsBar';
import styles from './CompactCallView.styles.m.css';
import { GroupAudioCall } from './GroupAudioCall/GroupAudioCall';
import { GroupVideoCall } from './GroupVideoCall/GroupVideoCall';

interface ICompactCallViewProps {
  className?: string;
  isMobile?: boolean;
}

export const CompactCallView: FC<ICompactCallViewProps> = observer(({ className }) => {
  const { call } = useCallContext();

  useEffect(() => {
    call.viewState.hideMembers();
  }, []);

  return (
    <div className={classNames(styles.container, className)}>
      {call.opponents.opponentsWithVideo.length > 0 ? <GroupAudioCall /> : <GroupVideoCall />}

      <EventsBar />
      <AnimatedBackgroundPanel isCompact />
    </div>
  );
});
